module.exports = __webpack_public_path__ + "static/media/external-link.f82babe7.svg";